import styled from 'styled-components'

export const Wrapper = styled.div`
  min-width: 160px;
  width: 160px;
  display: flex;
  flex-direction: column;
  font-weight: 400;
  margin-right: 16px;
`

export const InfoList = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
`
export const Header = styled.h5`
  font: var(--typography-8-10-bold);
  color: #717284;
  margin: 0 0 4px;
  word-break: normal;
`

export const Info = styled.div`
  font-size: 9px;
  line-height: 150%;
  font-weight: 500;
  color: #121432;

  :not(:last-child)::after {
    content: ', ';
  }

  ${props => props.highlight && 'color: #CC7400;'}
`
